import { IconEdit } from '@ui-lib';
import { motion } from 'motion/react';

import * as styles from './EditIndicator.css';

export const EditIndicator = (): JSX.Element => (
  <motion.div
    className={styles.EditIndicator}
    initial={{ opacity: 0 }}
    animate={{
      opacity: 1,
      transition: { duration: 0.2, delay: 0.05 },
    }}
  >
    <IconEdit />
  </motion.div>
);
